/**
 * Development shell.
 *
 * Layout only: every panel below owns its own behaviour. This is scaffolding that
 * proves the stack is wired -- React renders, the Vite proxy reaches the API, the API
 * reports on the database, and the language toggle drives the catalogs. The operator
 * scan flow replaces it.
 */

import { LanguageToggle } from './components/LanguageToggle.tsx';
import { SystemStatus } from './components/SystemStatus.tsx';
import { TranslationCheck } from './components/TranslationCheck.tsx';

export function App() {
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col gap-8 px-6 py-12">
      <header className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-3xl font-semibold">
            TES <span className="text-brand">Inspect</span>
          </h1>
          <p className="mt-1 text-ink-muted">Forklift daily inspection &mdash; development shell</p>
        </div>
        <LanguageToggle />
      </header>

      <Panel heading="System status">
        <SystemStatus />
      </Panel>

      <Panel heading="Translation check">
        <TranslationCheck />
      </Panel>

      <p className="text-sm text-ink-muted">
        Next: install PostgreSQL 17, then{' '}
        <code className="text-ink-secondary">npm run db:migrate</code>. See{' '}
        <code className="text-ink-secondary">HOW-TO-RUN.md</code>.
      </p>
    </main>
  );
}

function Panel({ heading, children }: { readonly heading: string; readonly children: React.ReactNode }) {
  return (
    <section className="rounded-lg border border-line bg-surface p-5">
      <h2 className="mb-4 text-sm font-semibold tracking-wide text-ink-muted uppercase">
        {heading}
      </h2>
      {children}
    </section>
  );
}
